export const mobioFitVideos = [
  {
    id: 61,
    contents: 10,
    name: {
      en: "ABS",
      no: "ABS",
      ar:"عضلات المعدة",
      tr: "Karın"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 602,
        name: "1 Plank (Low)",
        videoUrl: "https://cdn.mobiofit.com/ABS/1+Plank+(Low).mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/1+Plank+(Low).jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 603,
        name: "2 Side Plank Crunches",
        videoUrl: "https://cdn.mobiofit.com/ABS/2+Side+Plank+Crunches.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/2+Side+Plank+Crunches.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 604,
        name: "3 Shoulder Taps",
        videoUrl: "https://cdn.mobiofit.com/ABS/3+Shoulder+Taps.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/3+Shoulder+Taps.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 605,
        name: "4 Mountain Climbers",
        videoUrl: "https://cdn.mobiofit.com/ABS/4+Mountain+Climbers.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/4+Mountain+Climbers.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 606,
        name: "5 Crunches",
        videoUrl: "https://cdn.mobiofit.com/ABS/5+Crunches.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/5+Crunches.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 607,
        name: "6 Reverse Crunches",
        videoUrl: "https://cdn.mobiofit.com/ABS/6+Reverse+Crunches.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/6+Reverse+Crunches.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 608,
        name: "7 Bicycle Crunches",
        videoUrl: "https://cdn.mobiofit.com/ABS/7+Bicycle+Crunches.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/7+Bicycle+Crunches.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 609,
        name: "15 High Plank",
        videoUrl: "https://cdn.mobiofit.com/ABS/15+High+Plank.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/15+High+Plank.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 610,
        name: "21 Boat V-Sit",
        videoUrl: "https://cdn.mobiofit.com/ABS/21+Boat+V-Sit.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/21+Boat+V-Sit.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 611,
        name: "31 Plank Hip Dips",
        videoUrl: "https://cdn.mobiofit.com/ABS/31+Plank+Hip+Dips.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/ABS/31+Plank+Hip+Dips.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 62,
    contents: 7,
    name: {
      en: "Back",
      no: "Tilbake",
      ar:" الظهر",
      tr: "Geri"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 612,
        name: "Lat Pull Down",
        videoUrl: "https://cdn.mobiofit.com/Back/Lat+Pull+Down.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Back/Lat+Pull+Down.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 613,
        name: "Machine Seated Row",
        videoUrl: "https://cdn.mobiofit.com/Back/Machine+Seated+Row.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Back/Machine+Seated+Row.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 614,
        name: "Back extensions",
        videoUrl: "https://cdn.mobiofit.com/Back/Back+extensions.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Back/Back+extensions.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 615,
        name: "Body weight prone military press",
        videoUrl:
          "https://cdn.mobiofit.com/Back/Body+weight+prone+military+press.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Back/Body+weight+prone+military+press.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 616,
        name: "Body weight wall slides",
        videoUrl: "https://cdn.mobiofit.com/Back/Body+weight+wall+slides.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Back/Body+weight+wall+slides.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 617,
        name: "Floor Y raise",
        videoUrl: "https://cdn.mobiofit.com/Back/Floor+Y+raise.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Back/Floor+Y+raise.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 618,
        name: "Pilates Swimming",
        videoUrl: "https://cdn.mobiofit.com/Back/Pilates+Swimming.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Back/Pilates+Swimming.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 65,
    contents: 10,
    name: {
      en: "Glutes",
      no: "Glutes",
      ar:" الارداف",
      tr: "Kalça"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 628,
        name: "10 Superman",
        videoUrl: "https://cdn.mobiofit.com/Glutes/10+Superman.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Glutes/10+Superman.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 629,
        name: "12 Glutei Bridge",
        videoUrl: "https://cdn.mobiofit.com/Glutes/12+Glutei+Bridge.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Glutes/12+Glutei+Bridge.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 630,
        name: "13 One Leg Glutei Bridge",
        videoUrl:
          "https://cdn.mobiofit.com/Glutes/13+One+Leg+Glutei+Bridge.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Glutes/13+One+Leg+Glutei+Bridge.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 631,
        name: "14 Glutei Bridge + Adduction",
        videoUrl:
          "https://cdn.mobiofit.com/Glutes/14+Glutei+Bridge+%2B+Adduction.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Glutes/14+Glutei+Bridge+%2B+Adduction.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 632,
        name: "16 Straight-Leg Fire Hydrant",
        videoUrl:
          "https://cdn.mobiofit.com/Glutes/16+Straight-Leg+Fire+Hydrant.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Glutes/16+Straight-Leg+Fire+Hydrant.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 633,
        name: "17 Bent Knee Glutei Kickback",
        videoUrl:
          "https://cdn.mobiofit.com/Glutes/17+Bent+Knee+Glutei+Kickback.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Glutes/17+Bent+Knee+Glutei+Kickback.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 634,
        name: "20 Rainbow Kicks",
        videoUrl: "https://cdn.mobiofit.com/Glutes/20+Rainbow+Kicks.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Glutes/20+Rainbow+Kicks.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 635,
        name: "29 Leg Raises",
        videoUrl: "https://cdn.mobiofit.com/Glutes/29+Leg+Raises.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Glutes/29+Leg+Raises.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 636,
        name: "30 Alternating Leg Raises",
        videoUrl:
          "https://cdn.mobiofit.com/Glutes/30+Alternating+Leg+Raises.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Glutes/30+Alternating+Leg+Raises.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 637,
        name: "42 Standing Kickback",
        videoUrl: "https://cdn.mobiofit.com/Glutes/42+Standing+Kickback.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Glutes/42+Standing+Kickback.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 66,
    contents: 15,
    name: {
      en: "Mix",
      no: "Blande",
      ar:" متنوع",
      tr: "Karışık"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 638,
        name: "8 Reverse Plank",
        videoUrl: "https://cdn.mobiofit.com/Mix/8+Reverse+Plank.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/8+Reverse+Plank.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 639,
        name: "11 Bird Dog",
        videoUrl: "https://cdn.mobiofit.com/Mix/11+Bird+Dog.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/11+Bird+Dog.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 640,
        name: "18 Kneeling Push-Up",
        videoUrl: "https://cdn.mobiofit.com/Mix/18+Kneeling+Push-Up.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/18+Kneeling+Push-Up.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 641,
        name: "22 Side Plank",
        videoUrl: "https://cdn.mobiofit.com/Mix/22+Side+Plank.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/22+Side+Plank.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 642,
        name: "23 T-Plank",
        videoUrl: "https://cdn.mobiofit.com/Mix/23+T-Plank.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/23+T-Plank.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 643,
        name: "24 Up Down Plank",
        videoUrl: "https://cdn.mobiofit.com/Mix/24+Up+Down+Plank.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/24+Up+Down+Plank.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 644,
        name: "25 Plank Variation",
        videoUrl: "https://cdn.mobiofit.com/Mix/25+Plank+Variation.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/25+Plank+Variation.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 645,
        name: "26 R TWIST",
        videoUrl: "https://cdn.mobiofit.com/Mix/26+R+TWIST.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/26+R+TWIST.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 646,
        name: "27 Crab Toe Touch",
        videoUrl: "https://cdn.mobiofit.com/Mix/27+Crab+Toe+Touch.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/27+Crab+Toe+Touch.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 647,
        name: "28 Crab Reach",
        videoUrl: "https://cdn.mobiofit.com/Mix/28+Crab+Reach.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/28+Crab+Reach.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 648,
        name: "36 Jumping Jacks",
        videoUrl: "https://cdn.mobiofit.com/Mix/36+Jumping+Jacks.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/36+Jumping+Jacks.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 649,
        name: "37 March In Place",
        videoUrl: "https://cdn.mobiofit.com/Mix/37+March+In+Place.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/37+March+In+Place.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 650,
        name: "38 Run In Place",
        videoUrl: "https://cdn.mobiofit.com/Mix/38+Run+In+Place.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/38+Run+In+Place.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 651,
        name: "40 Standing Criss Cross",
        videoUrl: "https://cdn.mobiofit.com/Mix/40+Standing+Criss+Cross.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Mix/40+Standing+Criss+Cross.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 652,
        name: "41 Quick Steps Forwards-Backwards Quick Steps In And Out",
        videoUrl:
          "https://cdn.mobiofit.com/Mix/41+Quick+Steps+Forwards-Backwards+Quick+Steps+In+And+Out.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Mix/41+Quick+Steps+Forwards-Backwards+Quick+Steps+In+And+Out.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 67,
    contents: 7,
    name: {
      en: "Quads",
      no: "Firhjulinger",
      ar:" العضلة الرباعية",
      tr: "Üst Bacak"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 653,
        name: "9 Bear Crawl Into Plank Walkout With Legs",
        videoUrl:
          "https://cdn.mobiofit.com/Quads/9+Bear+Crawl+Into+Plank+Walkout+With+Legs.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Quads/9+Bear+Crawl+Into+Plank+Walkout+With+Legs.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 654,
        name: "19 Kneeling Hip Circles",
        videoUrl: "https://cdn.mobiofit.com/Quads/19+Kneeling+Hip+Circles.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Quads/19+Kneeling+Hip+Circles.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 655,
        name: "32 Forward Lunge",
        videoUrl: "https://cdn.mobiofit.com/Quads/32+Forward+Lunge.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Quads/32+Forward+Lunge.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 656,
        name: "34 Squat",
        videoUrl: "https://cdn.mobiofit.com/Quads/34+Squat.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Quads/34+Squat.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 657,
        name: "35 Pulse Squat",
        videoUrl: "https://cdn.mobiofit.com/Quads/35+Pulse+Squat.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Quads/35+Pulse+Squat.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 658,
        name: "39 Single Leg Death-Lift",
        videoUrl: "https://cdn.mobiofit.com/Quads/39+Single+Leg+Death-Lift.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Quads/39+Single+Leg+Death-Lift.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 659,
        name: "43 Step Back To High Knee",
        videoUrl:
          "https://cdn.mobiofit.com/Quads/43+Step+Back+To+High+Knee.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Quads/43+Step+Back+To+High+Knee.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 70,
    contents: 7,
    name: {
      en: "Legs",
      no: "Ben",
      ar:" أرجل",
      tr: "Bacaklar",
    },
    videos: [
      {
        duration: "Watch Now",
        id: 674,
        name: "Leg Curl",
        videoUrl: "https://cdn.mobiofit.com/Legs/Leg+Curl.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Legs/Leg+Curl.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 675,
        name: "Smith Machine Squat",
        videoUrl: "https://cdn.mobiofit.com/Legs/Smith+Machine+Squat.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Legs/Smith+Machine+Squat.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 676,
        name: "Curtsy Lunges",
        videoUrl: "https://cdn.mobiofit.com/Legs/Curtsy+Lunges.mp4",
        desc: "",
        preview:
          "https://mobiofit-contents.s3-eu-west-1.amazonaws.com/Legs/Curtsy+Lunges.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 677,
        name: "Lateral Lunges",
        videoUrl: "https://cdn.mobiofit.com/Legs/Lateral+Lunges.mp4",
        desc: "",
        preview:
          "https://mobiofit-contents.s3-eu-west-1.amazonaws.com/Legs/Lateral+Lunges.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 678,
        name: "Plie Squat",
        videoUrl: "https://cdn.mobiofit.com/Legs/Plie+Squat.mp4",
        desc: "",
        preview:
          "https://mobiofit-contents.s3-eu-west-1.amazonaws.com/Legs/Plie+Squat.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 679,
        name: "Single leg dead lift",
        videoUrl: "https://cdn.mobiofit.com/Legs/Single+leg+dead+lift.mp4",
        desc: "",
        preview:
          "https://mobiofit-contents.s3-eu-west-1.amazonaws.com/Legs/Single+leg+dead+lift.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 680,
        name: "Single leg Squat_ Donkey kicks",
        videoUrl:
          "https://cdn.mobiofit.com/Legs/Single+leg+Squat_+Donkey+kicks.mp4",
        desc: "",
        preview:
          "https://mobiofit-contents.s3-eu-west-1.amazonaws.com/Legs/Single+leg+Squat_+Donkey+kicks.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 69,
    contents: 7,
    name: {
      en: "Triceps",
      no: "Triceps",
      ar:" العضلة ثلاثية الرؤوس",
      tr: "Arka Kol"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 667,
        name: "Dumbbell Triceps Kickback",
        videoUrl:
          "https://cdn.mobiofit.com/Triceps/Dumbbell+Triceps+Kickback.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Triceps/Dumbbell+Triceps+Kickback.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 668,
        name: "Overhead Triceps Extension",
        videoUrl:
          "https://cdn.mobiofit.com/Triceps/Overhead+Triceps+Extension.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Triceps/Overhead+Triceps+Extension.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 669,
        name: "Bent over tricep extension",
        videoUrl:
          "https://cdn.mobiofit.com/Triceps/Bent+over+tricep+extension.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Triceps/Bent+over+tricep+extension.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 670,
        name: "Bilateral tricep kickback",
        videoUrl:
          "https://cdn.mobiofit.com/Triceps/Bilateral+tricep+kickback.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Triceps/Bilateral+tricep+kickback.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 671,
        name: "Chair Tricep Dips",
        videoUrl: "https://cdn.mobiofit.com/Triceps/Chair+Tricep+Dips.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Triceps/Chair+Tricep+Dips.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 672,
        name: "Overhead triceps extension",
        videoUrl:
          "https://cdn.mobiofit.com/Triceps/Overhead+triceps+extension.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Triceps/Overhead+triceps+extension.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 673,
        name: "Standing tricep press down",
        videoUrl:
          "https://cdn.mobiofit.com/Triceps/Standing+tricep+press+down+.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Triceps/Standing+tricep+press+down.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 63,
    contents: 7,
    name: {
      en: "Biceps",
      no: "Biceps",
      ar:" العضلة ذات الرأسين",
      tr: "Kol"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 619,
        name: "Bar Biceps Curl",
        videoUrl: "https://cdn.mobiofit.com/Biceps/Bar+Biceps+Curl.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Biceps/Bar+Biceps+Curl.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 620,
        name: "Dumbbell Hammer Curl",
        videoUrl: "https://cdn.mobiofit.com/Biceps/Dumbbell+Hammer+Curl.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Biceps/Dumbbell+Hammer+Curl.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 621,
        name: "Bent over row",
        videoUrl: "https://cdn.mobiofit.com/Biceps/Bent+over+row.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Biceps/Bent+over+row.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 622,
        name: "Pull apart",
        videoUrl: "https://cdn.mobiofit.com/Biceps/Pull+apart.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Biceps/Pull+apart.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 623,
        name: "Standing 1-arm high bicep curl",
        videoUrl:
          "https://cdn.mobiofit.com/Biceps/Standing+1-arm+high+bicep+curl+.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Biceps/Standing+1-arm+high+bicep+curl.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 624,
        name: "Standing 1-arm low bicep curl",
        videoUrl:
          "https://cdn.mobiofit.com/Biceps/Standing+1-arm+low+bicep+curl+.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Biceps/Standing+1-arm+low+bicep+curl.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 625,
        name: "Tall-kneeling 1-arm pull-in",
        videoUrl:
          "https://cdn.mobiofit.com/Biceps/Tall-kneeling+1-arm+pull-in+.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Biceps/Tall-kneeling+1-arm+pull-in.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 68,
    contents: 7,
    name: {
      en: "Shoulders",
      no: "Skulder",
      ar:" أكتاف",
      tr: "Omuzlar"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 660,
        name: "Seated Shoulder Dumbbell Press",
        videoUrl:
          "https://cdn.mobiofit.com/Shoulders/Seated+Shoulder+Dumbbell+Press.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Shoulders/Seated+Shoulder+Dumbbell+Press.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 661,
        name: "Smith Machine Shoulder Press Behind Neck",
        videoUrl:
          "https://cdn.mobiofit.com/Shoulders/Smith+Machine+Shoulder+Press+Behind+Neck.mp4",
        desc: "",
        preview:
          "https://cdn.mobiofit.com/Shoulders/Smith+Machine+Shoulder+Press+Behind+Neck.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 662,
        name: "Inch worm",
        videoUrl: "https://cdn.mobiofit.com/Shoulders/Inch+worm.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Shoulders/Inch+worm.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 663,
        name: "Plank jacks",
        videoUrl: "https://cdn.mobiofit.com/Shoulders/Plank+jacks.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Shoulders/Plank+jacks.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 664,
        name: "Straight arm raises",
        videoUrl: "https://cdn.mobiofit.com/Shoulders/Straight+arm+raises.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Shoulders/Straight+arm+raises.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 665,
        name: "Thrusters",
        videoUrl: "https://cdn.mobiofit.com/Shoulders/Thrusters.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Shoulders/Thrusters.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 666,
        name: "Upright row",
        videoUrl: "https://cdn.mobiofit.com/Shoulders/Upright+row.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Shoulders/Upright+row.jpg",
        filename: "",
      },
    ],
  },
  {
    id: 64,
    contents: 2,
    name: {
      en: "Chest",
      ar:" صدر",
      tr: "Göğüs"
    },
    videos: [
      {
        duration: "Watch Now",
        id: 626,
        name: "Bench Press",
        videoUrl: "https://cdn.mobiofit.com/Chest/Bench+Press.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Chest/Bench+Press.jpg",
        filename: "",
      },
      {
        duration: "Watch Now",
        id: 627,
        name: "Dumbbell Bench Fly",
        videoUrl: "https://cdn.mobiofit.com/Chest/Dumbbell+Bench+Fly.mp4",
        desc: "",
        preview: "https://cdn.mobiofit.com/Chest/Dumbbell+Bench+Fly.jpg",
        filename: "",
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/constants/mobiofit_videos.js